export default __webpack_public_path__ + "static/media/Story.9fdd80d1.png";